var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("user-header", {
    attrs: {
      infoObj: _vm.infoObj
    }
  }), _c("div", [_c("a-card", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("离职类型"),
      prop: "resignType"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("离职类型")
    },
    model: {
      value: _vm.dataFrom.resignType,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "resignType", $$v);
      },
      expression: "dataFrom.resignType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("被动离职")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("主动离职")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("离职日期"),
      prop: "resignAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      allowClear: "",
      format: _vm.getFormatDate(),
      valueFormat: "YYYY-MM-DD"
    },
    model: {
      value: _vm.dataFrom.resignAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "resignAt", $$v);
      },
      expression: "dataFrom.resignAt"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("离职原因"),
      prop: "resignReason"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "95%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("离职原因"),
      allowClear: "",
      maxLength: 100
    },
    model: {
      value: _vm.dataFrom.resignReason,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "resignReason", $$v);
      },
      expression: "dataFrom.resignReason"
    }
  })], 1)], 1)], 1)], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center",
      margin: "30px auto"
    }
  }, [_c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };